import { render, staticRenderFns } from "./basicInfoDetail.vue?vue&type=template&id=42ee681f&scoped=true"
import script from "./basicInfoDetail.vue?vue&type=script&lang=js"
export * from "./basicInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./basicInfoDetail.vue?vue&type=style&index=0&id=42ee681f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ee681f",
  null
  
)

export default component.exports